const initializeAvailabilityCtas = (root = document) => {
  root.querySelectorAll('.dv-availability-cta').forEach((cta) => {
    if (cta.dataset.dvCtaReady === 'true') return;

    const ring = cta.querySelector('.dv-availability-cta__ring');
    if (!ring) return;

    const setPlaybackRate = (rate) => {
      const animation = ring
        .getAnimations()
        .find(({ animationName }) => animationName === 'dv-availability-cta-spin');

      if (animation && typeof animation.updatePlaybackRate === 'function') {
        animation.updatePlaybackRate(rate);
      }
    };

    cta.addEventListener('pointerenter', () => setPlaybackRate(1.25));
    cta.addEventListener('pointerleave', () => setPlaybackRate(1));
    cta.addEventListener('focusin', () => setPlaybackRate(1.25));
    cta.addEventListener('focusout', (event) => {
      if (!cta.contains(event.relatedTarget)) setPlaybackRate(1);
    });

    cta.dataset.dvCtaReady = 'true';
  });
};

initializeAvailabilityCtas();
document.addEventListener('shopify:section:load', (event) => initializeAvailabilityCtas(event.target));
